<!--驾驶员自检记录详情弹窗-->
<template>
    <el-dialog :title="$t('public.Detail')" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false"
        @close="handleDialogClose">
        <div class="detail-content" v-loading="loading">
            <!-- 基本信息 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.basic_info') }}</el-divider>
            <el-row :gutter="20" class="info-row">
                <el-col :span="12">
                    <div class="info-item">
                        <span class="info-label">{{ $t('driverSelfCheck.driver_name') }}:</span>
                        <span class="info-value">{{ detail.DriverName }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="info-item">
                        <span class="info-label">{{ $t('driverSelfCheck.check_time') }}:</span>
                        <span class="info-value">{{ detail.CheckTime }}</span>
                    </div>
                </el-col>
            </el-row>

            <!-- ①体温 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.temperature') }}</el-divider>
            <div class="info-item">
                <span class="info-label">{{ $t('driverSelfCheck.temp_status') }}:</span>
                <span class="info-value">{{ detail.TempType }}</span>
            </div>
            <div class="info-item" v-if="detail.TempValue != null && detail.TempValue !== '' && detail.TempValue !== undefined && Number(detail.TempValue) > 0">
                <span class="info-label">{{ $t('driverSelfCheck.temp_value') }}:</span>
                <span class="info-value">{{ Math.round(Number(detail.TempValue) * 10) / 10 }}℃</span>
            </div>

            <!-- ②感冒症状 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.cold_symptoms') }}</el-divider>
            <div class="tag-list">
                <el-tag v-for="(item, i) in splitText(detail.ColdSymptom)" :key="'c' + i" size="small"
                    class="tag-item">
                    {{ item }}
                </el-tag>
                <span v-if="!detail.ColdSymptom" class="empty-text">{{ $t('driverSelfCheck.no_data') }}</span>
            </div>

            <!-- ③疲劳与身体疼痛 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.fatigue_pain') }}</el-divider>
            <div class="tag-list">
                <el-tag v-for="(item, i) in splitText(detail.FatiguePain)" :key="'f' + i" size="small" type="warning"
                    class="tag-item">
                    {{ item }}
                </el-tag>
                <span v-if="!detail.FatiguePain" class="empty-text">{{ $t('driverSelfCheck.no_data') }}</span>
            </div>

            <!-- ④特殊身体异常 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.special_abnormal') }}</el-divider>
            <div class="tag-list">
                <el-tag v-for="(item, i) in splitText(detail.SpecialAbnormal)" :key="'s' + i" size="small" type="danger"
                    class="tag-item">
                    {{ item }}
                </el-tag>
                <span v-if="!detail.SpecialAbnormal" class="empty-text">{{ $t('driverSelfCheck.no_data') }}</span>
            </div>

            <!-- ⑤其他 -->
            <el-divider content-position="left">{{ $t('driverSelfCheck.other_desc') }}</el-divider>
            <div class="other-text">
                {{ detail.OtherDescription || $t('driverSelfCheck.no_data') }}
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">{{ $t('public.close') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'SelfCheckDetailDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        record: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            detail: {}
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadDetail();
            }
        }
    },
    methods: {
        //将字符串按分隔符拆分为标签数组
        splitText(str) {
            if (!str) return [];
            return String(str).split(/[;;]/).map(s => s.trim()).filter(Boolean);
        },
        loadDetail() {
            this.detail = Object.assign({}, {
                DriverName: this.record.DriverName,
                CheckTime: this.record.CheckTime
            });
            if (!this.record || !this.record.RecordID) {
                return;
            }
            this.loading = true;
            this.$api.queryInspectionRecordByRecordID({
                RecordID: this.record.RecordID
            }).then(res => {
                this.loading = false;
                if (res && res.code == 200 && res.data && res.data.length) {
                    const d = res.data[0];
                    this.detail = Object.assign({}, this.detail, {
                        DriverName: d.DriverName,
                        CheckTime: d.CreateTime,
                        TempType: d.TempType,
                        TempValue: d.TempValue,
                        ColdSymptom: d.ColdSymptom,
                        FatiguePain: d.FatiguePain,
                        SpecialAbnormal: d.SpecialAbnormal,
                        OtherDescription: d.OtherDescription
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        handleDialogClose() {
            this.detail = {};
            this.$emit('close');
        }
    }
};
</script>
<style scoped>
.detail-content {
    max-height: 70vh;
    overflow-y: auto;
    padding: 10px;
}

.info-row {
    margin-bottom: 16px;
}

.info-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
}

.info-label {
    font-weight: 500;
    color: #606266;
    margin-right: 8px;
    min-width: 120px;
}

.info-value {
    color: #303133;
}

.el-divider {
    margin: 24px 0 16px 0;
}

.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0;
}

.tag-item {
    margin: 0;
}

.empty-text {
    color: #c0c4cc;
    font-size: 13px;
}

.other-text {
    color: #303133;
    line-height: 1.6;
    padding: 4px 0;
    white-space: pre-wrap;
    word-break: break-all;
}
</style>